<template>
  <div class="card-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t("devices.dictionary.title2") }}</span>
      <span v-else>编辑单词</span>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="120px"
          :model="poetry"
          @submit.native.prevent
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item :label="$t('devices.dictionary.word')" prop="word">
            <el-input v-model="poetry.word" class="fl"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('devices.dictionary.phonetic')" prop="phonetic">
            <el-input v-model="poetry.phonetic" class="fl"
            ></el-input>
          </el-form-item>

          <el-form-item  :label="$t('devices.dictionary.translations')"  prop="translations">
            <el-input
                type="textarea"
                :rows="10"
                placeholder="请输入内容"
                v-model="poetry.translations">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["userInfo"])
  },
  data() {
    return {
      poetry: {
        word: '',
        phonetic: '',
        translations: ''
      },
      rules: {
        word: [
          {
            required: true,
            message: this.$t("devices.poetry.inputWord"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    getStardictDetail() {
      this.$http.getStardictItemDetail({_id: this.$route.query.id}).then(ret => {
        for (let item in this.poetry) {
          this.poetry[item] = ret.data[item];
        }
        this.poetry.translations = ret.data.translations.join('\n')
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.$route.query.id) {
            this.edit();
          } else {
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    create() {
      this.$http.stardictseEistWord({word: this.poetry.word, type: this.$route.query.type}).then(res => {
        if (!res.data) {
          this.poetry['type'] = this.$route.query.type
          this.poetry['translations'] = this.poetry.translations
          this.$http.addStardictItem(this.poetry).then(res => {
            this.$router.back();
          })
        } else {
          this.elMsg(this.$t("alertMsg.existWord"), "warning");
        }
      })
    },

    edit() {
      this.$http.stardictseEistWord({word: this.poetry.word, type: this.$route.query.type}).then(res => {
        if (!res.data) {
          this.poetry['_id'] = this.$route.query.id
          this.poetry['translations'] = this.poetry.translations
          this.$http.editStardictItem(this.poetry).then(res => {
            this.elMsg(this.$t("alertMsg.modifySuccess"), "success");
            this.$router.back();
          })
        } else {
          this.elMsg(this.$t("alertMsg.existWord"), "warning");
        }
      })
    }
  },
  mounted() {
    if (!this.$route.query.id) return;
    this.getStardictDetail();
  }
};
</script>

<style lang="scss">
.card-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
      .card-mgt-fileName {
        margin-right: 10px;
      }
      .card-import-btn {
        margin-top: 10px;
      }
    }
  }
}
</style>
